module.exports = __webpack_public_path__ + "static/media/view6.ec89d1bf.jpg";